<div class="brain-asset-detail">
  <ng-template #loading>loading</ng-template>

  <div *ngIf="(productDetail$ | async) as productDetail">
    <div class="container-fluid header">
      <!--  HEADER -->
      <div class="row">
        <div class="col-12 px-0 d-none d-md-block">
          <aihub-breadcrumb class="ml-4"></aihub-breadcrumb>
        </div>

        <div class="col-12">
          <div class="container mx-auto d-flex justify-content-between pb-4">
            <div class="order-1 order-sm-0 mt-2 mt-sm-5 text" id="text">
              <div class="header-title font-size-lg">
                {{ productDetail.detail.name }}
              </div>
              <div class="header-subtitle">
                {{ productDetail.summary.short_description }}
              </div>
            </div>
            <div class="mt-sm-5 order-0 order-sm-1 d-flex" id="photo">
              <img
                [src]="productDetail.summary.icon_url | safe:'resourceUrl'"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- TOP MENU -->
      <div class="row d-none d-xl-block" aihubStickyDirective>
        <div class="col">
          <div
            *ngIf="categories"
            class="categories d-flex justify-content-center"
          >
            <div
              *ngFor="let cat of categories"
              class="categories-item flex-fill text-center"
              [brainAssetDetailSectionMenuItem]="cat"
              id="menu-{{cat}}"
            >
              {{cat | assetDetailFormatHeader }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- RENDER OVERVIEW -->
      <brain-asset-detail-overview> </brain-asset-detail-overview>

      <!-- RENDER FEATURES -->
      <brain-asset-detail-features
        *ngIf="productDetail.detail.capabilities?.length"
      >
      </brain-asset-detail-features>

      <!-- RENDER TEXT SECTIONS -->
      <brain-asset-detail-markdown
        *ngFor="let textSection of productDetail.detail.text_sections"
        [markdown]="textSection.text"
        [title]="textSection.title"
      >
      </brain-asset-detail-markdown>

      <!-- RENDER MATERIALS -->
      <brain-asset-detail-markdown
        *ngIf="productDetail.detail.materials.length"
        [markdown]="productDetail.detail.materials"
        [title]="'Materials'"
      >
      </brain-asset-detail-markdown>

      <!-- RENDER CONTENT TO THE END -->
      <ng-content></ng-content>
    </div>
  </div>
</div>
